// @ts-nocheck - stop typeerror on Controlled component.  TS does not recognise that this is controlled via a HOC
import React, { useEffect } from 'react';
import { get } from 'lodash-es';
import { useField } from 'react-form';
import { DropDown } from '@hummingbirdtechgroup/wings-ui';
import { ValidationMessage } from '..';
const Select = (props) => React.createElement(DropDown, { ...props });
const ControlledSelect = (props) => {
    const { value, field, validations = [] } = props;
    const handleChange = data => setValue(data);
    const { meta: { error, isTouched, isValidating }, getInputProps, setValue, } = useField(field, {
        validate: value => {
            const failingValidation = validations.find(validation => !validation.isValid(value));
            return get(failingValidation, 'message', false);
        },
    });
    useEffect(() => {
        setValue(value);
    }, [value]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Select, { ...getInputProps(props), onChange: handleChange }),
        !isValidating && isTouched && error && (React.createElement(ValidationMessage, null, error))));
};
Select.Controlled = ControlledSelect;
export default Select;
//# sourceMappingURL=Select.js.map